<template>
  <app-content>
    <app-content-body>

      <div class="inner">
        <p class="buttons">
          <a
              class="btn btn_action btn_add"
              title="Přidat stát"
              @click.prevent="createItem"
          >Přidat stát</a>
        </p>
        <h1 v-translate>Státy</h1>
      </div>

      <app-table
              clickable
              deletable
              noPagination
              :data="items"
              :highlight-rows-on-hover="true"
              :order="params.order"
              :page-size="params.limit"
              @sort="sortItems"
              @rowClick="goToDetail"
              @deleteRow="deleteItem"
              :loading="pending"
      >
        <template slot="header">
          <app-table-header-item class="field_left">
            <app-input
                    :label="translations.search"
                    name="search"
                    type="search"
                    v-model="search"
            />
          </app-table-header-item>
          <app-table-header-item class="field_right">
            <app-table-header-select :label="translations.showInDashboard">
              <app-select
                :options="showInDashboardSelect"
                v-model.trim="params.showInDashboard"
                @change="fetchItems(true)"
              />
            </app-table-header-select>
          </app-table-header-item>
        </template>

        <app-table-column first sortable attribute="countryNames" :label="translations.name">
          <template slot-scope="row">
            <strong>
              <div v-html="row.countryName" />
            </strong>
          </template>
        </app-table-column>
        <app-table-column sortable attribute="isoCode" :label="translations.isoCode" />
        <app-table-column sortable attribute="numberOfSynonyms" :label="translations.numberOfSynonyms" />
        <app-table-column sortable attribute="showInDashboard" :label="translations.showInDashboard">
          <template slot-scope="row">
            <app-graphic-image :value="row.showInDashboard" />
          </template>
        </app-table-column>
        <app-table-column sortable attribute="created" :label="translations.created">
          <template slot-scope="row">
            <div v-html="formatDate(row._created)" />
          </template>
        </app-table-column>

        <template slot="footer" v-if="itemsMetadata.totalCount > params.limit">
          <app-table-pagination
              :page="listPage"
              :itemsPerPage="params.limit"
              :totalCount="itemsMetadata.totalCount"
              @pageChanged="tablePageChanged"
          />
        </template>

      </app-table>
    </app-content-body>
  </app-content>
</template>

<script>
import getItemsListMixin from 'mixins/getItemsListMixin'
import appTitleMixin from 'mixins/appTitleMixin'
import formatDateMixin from 'mixins/formatDateMixin'

const itemsListMixin = getItemsListMixin({
  apiMethodsSuffix: 'Countries',
  detailRouteName: 'country'
})

export default {
  name: 'country-items',
  mixins: [formatDateMixin, itemsListMixin, appTitleMixin(['Státy'])],
  data() {
    return {
      search: ''
    }
  },
  created() {
    this.search = this.params.search
  },
  computed: {
    translations() {
      return {
        search: this.$gettext('Vyhledávání'),
        name: this.$gettext('Název'),
        isoCode: this.$gettext('ISO 3166-1 alpha-3'),
        created: this.$gettext('Založeno'),
        numberOfSynonyms: this.$gettext('Počet synonym'),
        showInDashboard: this.$gettext('Zobrazit v dashboardu'),
      }
    },
    currentLanguage() {
      return this.$language.current
    },
    currentTitle() {
      return [
        this.$gettext('Státy')
      ]
    },
    showInDashboardSelect() {
      return [
        { name: this.$gettext('Nevybráno'), value: null },
        { name: this.$gettext('Ano'), value: true },
        { name: this.$gettext('Ne'), value: false }
      ]
    },
  },
  methods: {
    shouldRefreshAfterDelete() {
      return true
    }
  },
  watch: {
    currentLanguage() {
      this.fetchItems()
    },
    items() {
      this.items.forEach(e => e.numberOfSynonyms = e.synonyms.length)
    },
    search: function (newVal, oldVal) {
      if (newVal.length >= 2) {
        this.params.search = this.search
        this.fetchItems()
      } else if (newVal.length < 2 && oldVal.length >= 2) {
        this.params.search = ''
        this.fetchItems()
      }
    }
  }
}
</script>
